<template>
    <tr>
        <td class="editor-content editor-label">Text Align</td>
        <td class="editor-content">
            <select class="form-control editor-form editor-select" v-model="selectedComponent.style.align">
                <option value="text-left">left</option>
                <option value="text-center">center</option>
                <option value="text-right">right</option>
            </select>
        </td>
    </tr>
</template>

<script>
    export default {
        name: 'TextAlignSelector',
        props: ['selectedComponent'],
        data () {
            return {
                model: webase.model
            }
        }
    }
</script>
